import $ from 'jquery';
import {
  $Doc,
  $Win
} from "../utils/jQueryGlobals";
import { gsapSingleton, scrollTriggerSingleton } from "../gsap";
const gsap = gsapSingleton();
const ScrollTrigger = scrollTriggerSingleton();

gsap.registerPlugin(ScrollTrigger);

let lastScrollTop = 0;


$Win.on('scroll', () => {
  const currentScrollTop = $Doc.scrollTop();

  if (window.innerWidth > 1024) {
    // Desktop: nascondi in basso, mostra in alto.
    if (currentScrollTop > lastScrollTop && currentScrollTop > 100) {

      $('header').addClass('scroll-down').removeClass('scroll-up');
    } else {

      $('header').addClass('scroll-up').removeClass('scroll-down');
    }
    lastScrollTop = Math.max(currentScrollTop, 0);
    $('.header-banner').removeClass('hide-banner');

  } else {

    if (currentScrollTop > 10) {
      $('.header-banner').addClass('hide-banner');
    } else {
      $('.header-banner').removeClass('hide-banner');
    }
    $('header').removeClass('scroll-down scroll-up');
  }

  // Classe .no-top dopo 190px (invariata)
  if (currentScrollTop > 190) {
    $('header').addClass('no-top');
  } else {
    $('header').removeClass('no-top');
  }
});


$Win.on('mousemove', function(event) {
    if (window.innerWidth > 1024) {
        if (event.clientY < 60) {
            $('header').addClass('scroll-up').removeClass('scroll-down');
        }
    }
});

// Padding dinamico per il main-content in base all'altezza dell'header
function setMainContentPadding() {
    let padding = 0;
    if (window.innerWidth <= 1024) {
        // Somma banner + top-header su mobile
        padding += $('.header-banner').outerHeight() || 0;
        padding += $('.top-header').outerHeight() || 0;
    } else {
        // Solo header su desktop
        padding = $('header').outerHeight() || 0;
    }
    $('#main-content').css('padding-top', padding + 'px');
}
setMainContentPadding();
$(window).on('resize', setMainContentPadding);

// Aggiorna il padding se l'header cambia classe (es: scroll-up/down)
const observer = new MutationObserver(setMainContentPadding);
observer.observe(document.querySelector('header'), { attributes: true, attributeFilter: ['class', 'style'] });
$(window).on('load', setMainContentPadding);

//-------- menu mobile ---------
$(document).on('click', '.hamburger', function () {
  // Toggle menu
  $('.mobile-menu').toggleClass('open');
  $('body').toggleClass('no-scroll');
  if ($('.mobile-menu').hasClass('open')) {
    $('body').addClass('menu-open');
    // Mostra icona close, nascondi hamburger
    $('.hamburger').addClass('hidden');
    $('.hamburger.close').removeClass('hidden');
  } else {
    $('body').removeClass('menu-open');
    // Mostra hamburger, nascondi icona close
    $('.hamburger').removeClass('hidden');
    $('.hamburger.close').addClass('hidden');
  }
});

function setMobileMenuPosition() {
  if (window.innerWidth <= 1024) {
    let top = 0;
    // Somma il banner solo se è visibile
    if (!$('.header-banner').hasClass('hide-banner')) {
      top += $('.header-banner').outerHeight() || 0;
    }
    top += $('.top-header').outerHeight() || 0;
    $('.mobile-menu').css({
      top: top + 'px',
      height: `calc(100dvh - ${top}px)`
    });
  } else {
    $('.mobile-menu').css({ top: '', height: '' });
  }
}

$('.mobile-menu .menu-item-has-children').on('click', function (e) {
  e.stopPropagation();
  // Chiudi tutti gli altri sottomenu
  $('.mobile-menu .menu-item-has-children').not(this).removeClass('open-submenu');
  $('.mobile-menu .menu-item-has-children .sub-menu').not($(this).children('.sub-menu')).removeClass('open');
  // Toggle solo quello cliccato
  $(this).toggleClass('open-submenu');
  $(this).children('.sub-menu').toggleClass('open');
});

// Chiama la funzione su resize, avvio e scroll
setMobileMenuPosition();
$(window).on('resize', setMobileMenuPosition);
$(window).on('scroll', setMobileMenuPosition);
$(window).on('load', setMobileMenuPosition);


document.addEventListener('DOMContentLoaded', function() {

    const menuContainer = document.querySelector('header #menu-main-menu');
    if (!menuContainer) return; 

    const nav_list = menuContainer.querySelectorAll('li');
    const overlay = document.querySelector('.overlay');
    if (!overlay) return; 

    let leaveTimeout;


    const positionOverlay = (targetLi) => {
        const position = targetLi.getBoundingClientRect();
        overlay.style.left = `${position.x}px`;
        overlay.style.width = `${position.width}px`;
        overlay.classList.add('active');
    };


    const setOverlayOnCurrentItem = () => {
        const currentActiveItem = menuContainer.querySelector('.current-menu-item');
        if (currentActiveItem) {
            const topLevelLi = currentActiveItem.closest('header #menu-main-menu > li');
            if (topLevelLi) {
                positionOverlay(topLevelLi);
            }
        } else {
            overlay.classList.remove('active');
        }
    };

    nav_list.forEach((listItem) => {
        listItem.addEventListener('mouseover', () => {
            clearTimeout(leaveTimeout);
            const topLevelLi = listItem.closest('header #menu-main-menu > li');
            if (topLevelLi) {
                positionOverlay(topLevelLi);
            }
        });

        listItem.addEventListener('mouseleave', () => {
            leaveTimeout = setTimeout(setOverlayOnCurrentItem, 250);
        });
    });
    setOverlayOnCurrentItem();
});
